const ITEMS = ["asistentesvirtual.com", "sin oficina", "sin nóminas", "sin permanencia", "planes a medida"];

export default function Marquee() {
  const line = [...ITEMS, ...ITEMS];
  return (
    <div className="overflow-hidden border-y border-brand-line bg-white py-6" data-testid="marquee">
      <div className="marquee-track">
        {line.map((t, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-8">
            <span className="text-2xl sm:text-4xl font-medium tracking-tight text-brand-ink whitespace-nowrap">
              {t}
            </span>
            <span className="h-2 w-2 rounded-full bg-brand-mint" />
          </span>
        ))}
      </div>
    </div>
  );
}
